import {
  Text,
  Stack,
  Box,
  Columns,
  Column,
  ButtonIcon,
  IconArrow,
} from 'braid-design-system';
import React from 'react';

import type { Card } from 'src/types';

import { LoadingItem } from '../LoadingBlock/LoadingBlock';

import { CardContent } from './CardContent/CardContent';

interface ColumnCardButtonProps {
  label: string;
  onClick: () => void;
}

interface ColumnCardProps {
  name: Card;
  title: React.ReactNode;
  children: React.ReactNode;
  loader: React.ReactNode;
  loading?: boolean;
  buttonProps?: ColumnCardButtonProps;
}

export const ColumnCard = React.forwardRef(
  (
    { name, title, children, loading, loader, buttonProps }: ColumnCardProps,
    ref: React.Ref<HTMLElement>,
  ) => (
    <Box
      data={{ automation: `${name}${loading ? '-loading' : ''}-card` }}
      component="section"
      {...(ref ? { ref } : {})}
    >
      <Stack space="large">
        {loading ? (
          <LoadingItem type="heading" level="1" />
        ) : (
          <Columns space="medium" alignY="center">
            <Column>
              <Text size="large" weight="strong">
                {title}
              </Text>
            </Column>
            {buttonProps ? (
              <Column width="content">
                <ButtonIcon
                  id={`${name}-action-button`}
                  icon={<IconArrow direction="right" />}
                  variant="transparent"
                  label={buttonProps.label}
                  onClick={buttonProps.onClick}
                  data={{
                    automation: `${name}-card-action-button`,
                  }}
                />
              </Column>
            ) : null}
          </Columns>
        )}

        <CardContent name={name} loading={loading} loader={loader}>
          {children}
        </CardContent>
      </Stack>
    </Box>
  ),
);
